import React, { ReactElement, useEffect } from 'react';
import { classNames } from 'utils/css';

import styles from './EmptyBase.module.scss';
import { EmptyBaseProps } from './EmptyBase.types';

function EmptyBase({ children, onClose }: EmptyBaseProps): ReactElement {
  useEffect(() => {
    const closeModalTimer = window.setTimeout(() => {
      onClose();
    }, 3000);
    return () => {
      window.clearTimeout(closeModalTimer);
    };
  }, []);

  return (
    <div
      className={classNames(styles.baseWrapper, styles.emptyBaseWrapper)}
      data-testid="EmptyBase">
      {children}
    </div>
  );
}

export default EmptyBase;
